export const API_BASE_URL = (window as any).pubDocsApiBaseUrl;

export function getDocumentUrl(siteKey: string, documentId: string): string {
  const encodedSiteKey = encodeURIComponent(siteKey);

  return `${API_BASE_URL}/${encodedSiteKey}/documents/${documentId}`;
}
